"use client";

import React, { PropsWithChildren, useMemo } from "react";
import { usePathname } from "next/navigation";
import clsx from 'clsx';

import Link from "../NextJs/Link";

type ActiveLinkProps = React.ComponentProps<typeof Link> & {
    className?: string;
    activeClassName?: string;
    partiallyActive?: boolean;
    whiteList?: string[];
    href: string;
};

const ActiveLink = ({
    children, activeClassName, partiallyActive, whiteList = [], href,  className, ...rest
}: PropsWithChildren<ActiveLinkProps>) => {
    const pathname = usePathname();
    const isActive = useMemo(() => {
        let urlMatch = false;

        if (pathname === href) {
            urlMatch = true
        };

        if (partiallyActive) {
            if (pathname?.startsWith(href)) {
                urlMatch = true
            };
        }

        if (whiteList) {
            whiteList.map((s: string) => {
                if (pathname?.startsWith(s)) {
                    urlMatch = true
                };
            })
        }

        return urlMatch;
    }, [pathname, href, partiallyActive, whiteList]);

    const classNames = clsx(className, {
        [activeClassName || '']: isActive
    });

    return <Link href={href} className={classNames} {...rest}>{children}</Link>;
};

export default ActiveLink;
